<footer class="footer">
  <span class="footer__text">
    Made with
    <rt-icon name="bravos-filled" class="footer__icon" />
    at
    <a href="https://tellent.com" target="_blank" rel="noopener noreferrer" class="footer__link">
      Tellent
    </a>
  </span>
</footer>
